<script setup lang="ts">
import InstagramShareModal from '~/components/InstagramShareModal.vue';
import { GTM_TOP_SNS, GTM_RESULT_SNS } from '~/constants/gtm';

interface Props {
  url: string;
  snsText: {
    twitter: string;
    instagram: string;
    line: string;
  };
  snsHashtagText: {
    twitter: string | null;
    line: string | null;
  };
  instagramUrl: string;
  currentPage: 'result' | 'top';
}
const props = defineProps<Props>();
const GTM_SNS = computed(() =>
  props.currentPage === 'result' ? GTM_RESULT_SNS : GTM_TOP_SNS,
);
</script>

<template>
  <ul class="flex items-center gap-x-5">
    <li>
      <a
        :id="GTM_SNS.TWITTER"
        :href="`https://twitter.com/intent/tweet?url=${encodeURIComponent(
          url,
        )}&text=${
          encodeURIComponent(snsText.twitter) +
          (snsHashtagText.twitter
            ? `%0a${encodeURIComponent(snsHashtagText.twitter)}`
            : '')
        }`"
        rel="noopener noreferrer"
        target="_blank"
      >
        <Img src="/images/ranking/sns/sns_btn_01.svg" alt="X" />
      </a>
    </li>
    <li>
      <a
        :id="GTM_SNS.FACEBOOK"
        :href="`https://www.facebook.com/share.php?u=${encodeURIComponent(
          url,
        )}`"
        rel="noopener noreferrer"
        target="_blank"
      >
        <Img src="/images/ranking/sns/sns_btn_02.svg" alt="Facebook" />
      </a>
    </li>
    <li>
      <InstagramShareModal :url="instagramUrl">
        <template #trigger>
          <Img
            :id="GTM_SNS.INSTAGRAM"
            src="/images/ranking/sns/sns_btn_03.svg"
            alt="Instagram"
          />
        </template>
      </InstagramShareModal>
    </li>
    <li>
      <a
        :id="GTM_SNS.LINE"
        :href="`https://line.me/R/msg/text/?${
          encodeURIComponent(snsText.line) +
          encodeURIComponent(
            snsHashtagText.line ? `${snsHashtagText.line}` : '',
          )
        }%0a${encodeURIComponent(url)}`"
        rel="noopener noreferrer"
        target="_blank"
      >
        <Img src="/images/ranking/sns/sns_btn_04.svg" alt="LINE" />
      </a>
    </li>
  </ul>
</template>
